"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var ModalV2_1 = __importDefault(require("@src/components/ModalV2"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var text_2 = __importDefault(require("relements/build/esm/input/text"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var BinIcon_1 = __importDefault(require("relements/build/esm/ui/icons/BinIcon"));
var checkbox_1 = __importDefault(require("relements/build/esm/input/checkbox"));
var FIELD_TYPE_OPTIONS = [
    { id: '0', name: 'no type' },
    { id: '1', name: 'string' },
    { id: '2', name: 'number' },
    { id: '3', name: 'boolean' },
    { id: '4', name: 'array' },
];
var splitFieldId = 0;
var createField = function () { return ({
    id: "split-field-" + splitFieldId++,
    name: '',
    dataType: 'no type',
}); };
var INITIAL_FIELDS = [createField(), createField()];
var SplitModal = function (_a) {
    var _b;
    var active = _a.active, closeModal = _a.closeModal, data = _a.data, setData = _a.setData, onChange = _a.onChange, onUndo = _a.onUndo, originalSplitAction = _a.originalSplitAction;
    // Initialize fields from original split action if available
    var getInitialFields = function (splitAction) {
        if (splitAction && splitAction.final_names.length > 0) {
            return splitAction.final_names.map(function (name) {
                var _a, _b;
                return ({
                    id: "split-field-" + splitFieldId++,
                    name: name,
                    dataType: (_b = (_a = splitAction.final_types) === null || _a === void 0 ? void 0 : _a[name]) !== null && _b !== void 0 ? _b : 'no type',
                });
            });
        }
        return INITIAL_FIELDS;
    };
    var _c = react_1.useState(INITIAL_FIELDS), fields = _c[0], setFields = _c[1];
    var _d = react_1.useState(''), delimiter = _d[0], setDelimiter = _d[1];
    var _e = react_1.useState(false), includeDelimiter = _e[0], setIncludeDelimiter = _e[1];
    var handleClose = function () {
        setData(null);
        setFields(INITIAL_FIELDS);
        setDelimiter('');
        closeModal();
    };
    // Reset fields when modal opens with new data
    react_1.useEffect(function () {
        if (active) {
            if (originalSplitAction) {
                setFields(getInitialFields(originalSplitAction));
                // Handle delimiter - it might be undefined, null, empty string, or have a value
                // Check if delimiter exists and is not null/undefined, otherwise default to empty string
                var delimiterValue = originalSplitAction.delimiter != null
                    ? String(originalSplitAction.delimiter)
                    : '';
                setDelimiter(delimiterValue);
                setIncludeDelimiter(!!originalSplitAction.include_delimiter);
            }
            else {
                setFields(INITIAL_FIELDS);
                setDelimiter('');
            }
        }
    }, [active, originalSplitAction, data]);
    var handleFieldChange = function (index, key, value) {
        setFields(function (prev) {
            return prev.map(function (field, fieldIndex) {
                var _a;
                return fieldIndex === index
                    ? __assign(__assign({}, field), (_a = {}, _a[key] = key === 'dataType' ? value : value, _a)) : field;
            });
        });
    };
    var handleAddField = function () {
        setFields(function (prev) { return __spreadArrays(prev, [createField()]); });
    };
    var handleSplit = function () {
        var action = {
            action: 'split',
            delimiter: delimiter,
            include_delimiter: includeDelimiter,
            final_names: [],
            final_types: {},
        };
        fields.forEach(function (field) {
            action.final_names.push(field.name);
            action.final_types[field.name] = field.dataType;
        });
        // If this is a split row, use the original source column; otherwise use the current row id
        var sourceColumn = 'splitFrom' in (data || {}) ? data.splitFrom : data === null || data === void 0 ? void 0 : data.id;
        onChange(sourceColumn || '', action, !!originalSplitAction);
        handleClose();
    };
    var handleUndo = function () {
        if (onUndo) {
            // If this is a split row, use the original source column; otherwise use the current row id
            var sourceColumn = 'splitFrom' in (data || {}) ? data.splitFrom : data === null || data === void 0 ? void 0 : data.id;
            onUndo(sourceColumn || '');
            handleClose();
        }
    };
    // Get the column name to display - use original source for split rows
    var displayColumnName = data && 'splitFrom' in data ? data.splitFrom : (_b = data === null || data === void 0 ? void 0 : data.id) !== null && _b !== void 0 ? _b : '';
    return (react_1["default"].createElement(ModalV2_1["default"], { title: "Split Column: " + displayColumnName, subtitle: "", headerIcon: null, headerSubIcon: null, active: active, classPrefix: "splitModal", isV2: true, toggleModal: handleClose },
        react_1["default"].createElement(box_1["default"], { padding: "0", pb: "4px", flexDirection: "column", height: "40vh", overflow: "auto" },
            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "Delimiter"),
            react_1["default"].createElement(text_2["default"], { themed: true, placeholder: "Enter the delimiter", className: "delimiter", value: delimiter, onChange: function (value) { return setDelimiter(value); }, style: { marginTop: '4px' } }),
            react_1["default"].createElement(box_1["default"], { padding: "0", margin: "4px 0 16px", alignItems: "center", style: { gap: '4px' }, onClick: function () { return setIncludeDelimiter(function (prev) { return !prev; }); } },
                react_1["default"].createElement(checkbox_1["default"].Item, { themed: true, value: includeDelimiter }),
                react_1["default"].createElement(text_1["default"], { variant: "body.md", style: { marginLeft: '-16px', cursor: 'pointer' } }, "Include Delimiter")),
            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "New Field Names"),
            react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column" },
                fields.map(function (field, index) {
                    var _a;
                    return (react_1["default"].createElement(box_1["default"], { padding: "0", key: field.id, justifyContent: "space-between", alignItems: "center", style: { gap: '8px' }, marginBottom: index === fields.length - 1 ? '16px' : '8px', marginTop: index === 0 && '8px' },
                        react_1["default"].createElement(text_2["default"], { themed: true, placeholder: "Enter the field name", value: field.name, onChange: function (value) { return handleFieldChange(index, 'name', value); } }),
                        react_1["default"].createElement(dropdown_1["default"], { themed: true, placeholder: "Select field type", options: FIELD_TYPE_OPTIONS, optionKey: "name", value: (_a = FIELD_TYPE_OPTIONS.find(function (opt) { return opt.name === field.dataType; })) !== null && _a !== void 0 ? _a : FIELD_TYPE_OPTIONS[0], onChange: function (option) {
                                if (option === null || option === void 0 ? void 0 : option.name) {
                                    handleFieldChange(index, 'dataType', option.name);
                                }
                            }, style: { width: '48%' }, inputStyles: { marginTop: '-6px' }, optionsStyle: { zIndex: 1000000010 } }),
                        react_1["default"].createElement(box_1["default"], { padding: "0", style: { cursor: 'pointer' }, onClick: function () {
                                setFields(function (prev) { return prev.filter(function (_, idx) { return idx !== index; }); });
                            } }, fields.length > 2 && (react_1["default"].createElement(BinIcon_1["default"], { size: "small", iconColor: "red.haptik" })))));
                }),
                react_1["default"].createElement(text_1["default"], { role: "button", variant: "body.md", color: "blue.haptik", onClick: handleAddField, style: { cursor: 'pointer' } }, "+ Add another field"))),
        react_1["default"].createElement(box_1["default"], { padding: "0", justifyContent: "space-between", margin: "12px 0" }, originalSplitAction && onUndo ? (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", style: { width: '32%' }, onClick: handleClose }, "Cancel"),
            react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", style: { width: '32%' }, onClick: handleUndo }, "Undo"),
            react_1["default"].createElement(button_1["default"], { themed: true, variant: "primary", style: { width: '32%' }, onClick: handleSplit }, "Update"))) : (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(button_1["default"], { themed: true, variant: "secondary", style: { width: '48%' }, onClick: handleClose }, "Cancel"),
            react_1["default"].createElement(button_1["default"], { themed: true, variant: "primary", style: { width: '48%' }, onClick: handleSplit }, "Apply Split"))))));
};
exports["default"] = SplitModal;
